import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ICollectionCreditsResponse } from '../collection-credits-response';
import { collectionCreditsResponseSchema } from '../collection-credits-response';

export async function getPublicCollectionCreditsApi(
  slug: string,
): Promise<IValidatedResponse<ICollectionCreditsResponse>> {
  return getRequest<ICollectionCreditsResponse>({
    path: `/collections/v1/slug/${slug}/credits`,
    schema: collectionCreditsResponseSchema,
  });
}
